const newLocal = "https://reptec-back.vr.uff.br/";
const basicURL = newLocal;

const mediaLimitSize = 20;
export const mediaUploadLimit = mediaLimitSize;

export default basicURL;
